"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSWORD_PUBLIC_KEY = void 0;
exports.PASSWORD_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsbscjCjjMuYKc0+Dktqy
jm0YeYojrmANJqtGV3Qoj6w88FtTKe0ZOKyIuDddoimHqsg3+um8EhNq8VIQ/IHo
c2H1OwYTJGl/g6DIteXKp/DGtKvebCCxuGB0noZVWMzPeWwa+UdtVa4duXdiz3hb
M43zhiB0wD6MXWB5/6uRdn6J1us9cmsXYJk5dPTMWNtMmdKw42dYJGhdNUT8zmon
RRwNFbkeWvuzajRfNyi39uujHIyOceBo2Z75/4LVIfXCsMG9Qq7Iy/P2MASOJy5y
uNX+7s2F5mYaxIH8SE2ZLwHrXZs2sp8aa5ZR5j0ocp/tSeufZRkO2QwNbec8t04a
+wIDAQAB
-----END PUBLIC KEY-----`;
